import { render, staticRenderFns } from "./Impress.vue?vue&type=template&id=cb9a5c68&scoped=true"
import script from "./Impress.vue?vue&type=script&lang=js"
export * from "./Impress.vue?vue&type=script&lang=js"
import style0 from "./Impress.vue?vue&type=style&index=0&id=cb9a5c68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9a5c68",
  null
  
)

export default component.exports